import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { Icon } from "@qgiv/core-react";
import ModalStateContext from "./ModalStateContext";
import "./CreateTeamNav.scss";

const CreateTeamNav = ({ isVisible }) => {
    const { toggleActiveView } = React.useContext(ModalStateContext);
    const ariaLabel = "Back to Join Team";
    const createTeamNavRef = useRef(null);
    useEffect(() => {
        // The back arrow is only visible if a user can join a team in addition
        // to creating a new team
        // eslint-disable-next-line no-unused-expressions
        createTeamNavRef.current && createTeamNavRef.current.focus();
    }, []);
    return (
        isVisible && (
            <nav className="create-team-nav">
                <button
                    aria-label={ariaLabel}
                    className="create-team-nav__button -cursor--pointer"
                    onClick={() => {
                        toggleActiveView();
                    }}
                    type="button"
                    ref={createTeamNavRef}
                >
                    <Icon
                        type="FontAwesome"
                        glyph="chevron-left-solid"
                        label={ariaLabel}
                    />
                </button>
            </nav>
        )
    );
};

CreateTeamNav.propTypes = {
    isVisible: PropTypes.bool.isRequired,
};

export default CreateTeamNav;
